import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {KeyValueDto} from "../dto/key-value.dto";
import {DuckDbHelper} from "./duckdb.helper";
import {I18nRepo} from "../api/i18n.repo";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class I18nDuckDb extends I18nRepo {

  public override getCountries(): Observable<WrapperDto<KeyValueDto>> {
    return this.http.get<KeyValueDto[]>('assets/i18n/countries.json')
      .pipe(map((kv) => DuckDbHelper.datas('KeyValueDto', kv)));
  }

  public override getTimezones(): Observable<WrapperDto<KeyValueDto>> {
    return DuckDbHelper.datasObs('KeyValueDto', []);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getSectors(_filterCountryCode?: string): Observable<WrapperDto<KeyValueDto>> {
    return DuckDbHelper.datasObs('KeyValueDto', []);
  }
}
